export const STATUS_LABEL = {
  EM_PREVIA: "Em Prévia",
  ENVIADO: "Enviado",
  APROVADO: "Aprovado",
  CANCELADO: "Cancelado",
};

export const TIPO_LABEL = {
  "pis-cofins": "PIS/COFINS",
  esocial: "E-Social",
  icms: "ICMS",
};

const ROTULOS_VALOR = {
  "pis-cofins": { a: "PIS", b: "COFINS" },
  esocial: { a: "INSS Patronal", b: "Terceiros" },
  icms: { a: "ICMS-ST a recuperar", b: "Complemento" },
};

/**
 * Rótulos dos dois valores do projeto (A e B) por tipo; tipo desconhecido usa PIS/COFINS.
 * @param {string} [tipo]
 * @returns {{ a: string, b: string }}
 */
export function rotulosDoTipo(tipo) {
  return ROTULOS_VALOR[tipo] || ROTULOS_VALOR["pis-cofins"];
}

/**
 * Total de um grupo (Administrativo, Judicial ou uma oportunidade). O ICMS-ST vem da API já com o
 * complemento abatido e o piso mensal (`total`); nos demais tipos o total é a soma dos dois valores.
 * @param {{ pis: number, cofins: number, total?: number }} grupo
 * @returns {number}
 */
export function totalDoGrupo(grupo) {
  if (typeof grupo.total === "number") return grupo.total;
  return Math.round((grupo.pis + grupo.cofins + Number.EPSILON) * 100) / 100;
}

/**
 * Ações do Resumo do Projeto para o status atual, na ordem dos botões.
 * Editar (atualizar valores, enviar, liberar, cancelar) e aprovar são permissões distintas.
 * Aprovado é final: nenhuma ação.
 * @param {string} status
 * @param {{ podeEditar: boolean, podeAprovar: boolean }} permissoes
 * @returns {string[]}
 */
export function acoesDisponiveis(status, { podeEditar, podeAprovar }) {
  const acoes = [];
  if (status === "EM_PREVIA") {
    if (podeEditar) acoes.push("atualizar-valores", "enviar");
  } else if (status === "ENVIADO") {
    if (podeEditar) acoes.push("liberar", "cancelar");
    if (podeAprovar) acoes.push("aprovar");
  } else if (status === "CANCELADO") {
    if (podeEditar) acoes.push("enviar");
  }
  return acoes;
}

function dataValida(iso) {
  if (!iso) return null;
  const data = new Date(iso);
  return Number.isNaN(data.getTime()) ? null : data;
}

/** dd/mm/aaaa no fuso do navegador; "—" quando ausente ou inválida. */
export function formatarData(iso) {
  const data = dataValida(iso);
  return data ? data.toLocaleDateString("pt-BR") : "—";
}

/** dd/mm/aaaa às hh:mm no fuso do navegador; "—" quando ausente ou inválida. */
export function formatarDataHora(iso) {
  const data = dataValida(iso);
  if (!data) return "—";
  const hora = data.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });
  return `${data.toLocaleDateString("pt-BR")} às ${hora}`;
}
